import { opts } from '../opts.js';
import {
	parseAttributes,
	parseTemplate,
	getDelegateTarget,
	filterTitle
} from '../util/helpers.js';
import { connectCurrentRefinements } from '../../../../dist/vendor/instantsearch.js/es/connectors/index.js';


const refinement = ({ item, renderOptions }) => {
	const { widgetParams } = renderOptions;
	return item.refinements.map(refinement => {
		return parseTemplate( 'currentRefinements', {
				...widgetParams.cssClasses,
				...refinement,
				label: filterTitle(refinement.label),
				count: refinement.count && widgetParams.showCount
					? `(${refinement.count})`
					: '',
			});
	});
}

const firstRender = ({ items, widgetParams: { cssClasses: { activeLabel, list }, text, container }}) => {
	const forAtt = '';
	const label = items.length > 1
		? `
		<label class="${activeLabel}" for="${forAtt}">
			${text.label}
		</label>`
		: '';

	container.innerHTML = `
		${label}
		<ul class="${list}"></ul>
		`;
}

const renderRefinements = (renderOptions, isFirstRender ) => {
	const {
		items,
		refine,
		widgetParams
	} = renderOptions;

	isFirstRender && firstRender(renderOptions);

  	const wrap = widgetParams.container
		.querySelector(`.${widgetParams.cssClasses.list}`);

	if (!items.length) {
		return;
	}
	wrap.innerHTML =  `<p class="has-kicker-variant">Filters</p>` + items.map(item => refinement({ item, renderOptions })).join('');

	[...wrap.querySelectorAll('button')]
		.forEach(el => el.addEventListener('click',
			event => onRefinementClick(event, refine, widgetParams.cssClasses)));
}

const transformCurrent = items => items.map( item => ({
	...item,
}));

const onRefinementClick = (event, refine, cssClasses) => {
	const  el = getDelegateTarget(event, `.${cssClasses.item}`);
	const matchingFilter = document.querySelector(`input[value="${el.dataset.value}"]`);
	if (matchingFilter) {
		delete matchingFilter.checked;
	}
	el.dataset && refine(
		parseAttributes(el.dataset)
	);
	// if no remaining filters, remove label
	if (el.parentElement.children.length === 2) {  // heading + filter
		el.parentElement.innerHTML = '';
	} else {
		el.parentElement.removeChild(el);
	}
}

export const config = {
	...opts.currentRefinements,
	transformItems(items) {
		return transformCurrent(items);
	},
}

export const widget = connectCurrentRefinements(renderRefinements);
